import { render } from "./app.vue?vue&type=template&id=556af9ea&ts=true"
import script from "./app.ts?vue&type=script&lang=ts&external"
export * from "./app.ts?vue&type=script&lang=ts&external"

import "./styles/main.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__